import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en';
import ar from './ar';

// Storage key used by the detector and by the language-toggle component, so
// switching language survives reloads even before the user is signed in.
export const LNG_STORAGE_KEY = 'eit.lng';

// Whenever the language changes, flip <html lang>/<html dir> so the entire
// app (Tailwind, custom CSS, screen readers) re-orients consistently.
function applyHtmlDir(lng: string) {
    const dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
    document.documentElement.dir  = dir;
}

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ar: { translation: ar },
        },
        fallbackLng: 'en',
        supportedLngs: ['en', 'ar'],
        interpolation: { escapeValue: false },
        detection: {
            order:  ['localStorage', 'navigator', 'htmlTag'],
            lookupLocalStorage: LNG_STORAGE_KEY,
            caches: ['localStorage'],
        },
        returnNull: false,
    })
    .then(() => applyHtmlDir(i18n.language || 'en'));

i18n.on('languageChanged', (lng) => applyHtmlDir(lng));

export default i18n;
